import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const pains = ['Querés entrenar, pero no te da la semana.', 'Arrancás motivado y a los 10 días ya estás atrasado.', 'Sentís que todos los planes están hechos para gente con demasiado tiempo libre.', 'No sabés cómo combinar natación, bici, running, fuerza y descanso.', 'Te da miedo anotarte a una carrera y llegar mal preparado.', 'Pensás: "Me encantaría hacer triatlón, pero mi vida no me lo permite."'];
export function PainPoints() {
  return <section className="py-24 bg-black" data-id="element-74">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="text-center mb-12" data-id="element-76">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-77">
            Si te pasa esto, el problema{' '}
            <span className="text-brand-green" data-id="element-78">no sos vos</span>
          </h2>
        </div>

        <div className="space-y-3 mb-12" data-id="element-79">
          {pains.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 bg-white/5 border border-white/10 rounded-xl p-4 hover:border-brand-green/30 transition-colors" data-id="element-80">
              <div className="flex-shrink-0 w-7 h-7 rounded-full bg-red-500/15 text-red-400 flex items-center justify-center mt-0.5" data-id="element-81">
                <X size={16} strokeWidth={2.5} data-id="element-82" />
              </div>
              <p className="text-white/90 leading-relaxed text-base md:text-lg" data-id="element-83">
                {p}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8" data-id="element-84">
          <p className="font-serif text-2xl md:text-3xl text-white leading-tight" data-id="element-85">
            No te falta disciplina.
            <br data-id="element-86" />
            Te falta un{' '}
            <span className="text-brand-green font-bold" data-id="element-87">
              sistema pensado para tu vida real
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}